import { useMutation } from "@tanstack/react-query";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "react";
import "axios";
const postOutgoingCall = (axios) => async (params) => {
  const { data } = await axios.post("/api/outgoing-calls", params);
  return data;
};
const useCallPatient = ({ onCallSuccess }) => {
  const { operator } = useAxiosProvider();
  return useMutation(postOutgoingCall(operator), {
    onSuccess: () => onCallSuccess == null ? void 0 : onCallSuccess()
  });
};
export {
  useCallPatient
};
